import React, { useEffect, useState } from "react";
import { RoundedButton } from "@bloomberg/media-ui-core";
import { Plus, WeekendLogo } from "@bloomberg/media-ui-icons";

import { TranslatedMessage } from "~i18n/translate";
import { selectUserSubscribedNewsletters } from "~redux/features/user-slice";
import useRedux from "~redux/hooks";

import styles from "./WeekendHeader.module.css";

const NEWSLETTER_SIGNUP_URL = "/account/newsletters/weekend-edition";
const WEEKEND_NEWSLETTER_ID = "Weekend Edition";

export default function WeekendHeader({ titleUrl }: { titleUrl: string }) {
    const [isSignedUp, setIsSignedUp] = useState(false);
    const { useAppSelector } = useRedux();
    const userSubscribedNewsletters = useAppSelector(
        selectUserSubscribedNewsletters
    );

    useEffect(() => {
        if (
            userSubscribedNewsletters &&
            userSubscribedNewsletters.includes(WEEKEND_NEWSLETTER_ID)
        ) {
            setIsSignedUp(true);
        }
    }, [userSubscribedNewsletters]);

    return (
        <div className={styles.WeekendHeader} data-component="weekend-header">
            <a href={titleUrl}>
                <WeekendLogo className={styles.logo} />
            </a>
            {!isSignedUp && (
                <div className={styles.newsletter}>
                    <a href={NEWSLETTER_SIGNUP_URL}>
                        <RoundedButton
                            Icon={<Plus />}
                            iconPosition="left"
                            version="phoenix"
                            disabled={false}
                        >
                            <TranslatedMessage
                                id="getTheNewsletter"
                                defaultMessage="Get the Newsletter"
                            />
                        </RoundedButton>
                    </a>
                </div>
            )}
        </div>
    );
}
